export default {
	"0": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Mensaje del servidor"
		}
	},
	"1": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error general"
		}
	},
	"2": {
		"categoria" : 'important',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Se ha perdido la sesión"
		}
	},
	"3": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "El usuario o la contraseña proporcionados no son válidos. Revisa los datos, utiliza la funcionalidad de recuperar contraseña o contacta con nosotros en caso de que tengas cualquier duda."
		}
	},
	"4": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se ha encontrado la oferta"
		}
	},
	"6": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta va dirigida a empleo"
		}
	},
	"7": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta va dirigida a prácticas"
		}
	},
	"8": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El dato existía previamente"
		}
	},
	"9": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "Lo sentimos, el usuario que has indicado o pertenece a una empresa que no está validada en el sistema, o ha sido bloqueado. Por favor contacta con nosotros si si tienes cualquier consulta."
		}
	},
	"10": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya es candidato"
		}
	},
	"11": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Falta documentación necesaria"
		}
	},
	"12": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error enviando el email"
		}
	},
	"13": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede gestionar la oferta"
		}
	},
	"14": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede pasar al estado seleccionado desde el actual"
		}
	},
	"15": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Faltan datos obligatorios"
		}
	},
	"16": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Alta rechazada",
			"cuerpo" : "Ya hay un usuario registrado con el email indicado. En caso de no recordar tu usuario o tener cualquier problema, por favor contacta con nosotros."
		}
	},
	"17": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puedes inscribirte a la oferta porque se solapa con su práctica"
		}
	},
	"18": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puedes inscribirte a la oferta, es para estudiantes de grado"
		}
	},
	"19": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puedes inscribirte a la oferta, es para estudiantes de postgrado"
		}
	},
	"20": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No tiene servicio de empleo"
		}
	},
	"21": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No tiene servicio de prácticas"
		}
	},
	"22": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No está identificado como UTP ni como UTE"
		}
	},
	"23": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No apareces matriculado de prácticas ponte en contacto con nosotros para solucionarlo"
		}
	},
	"24": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Hay un problema con su empresa. Póngase en contacto con el administrador"
		}
	},
	"25": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta ya tienen un gestor asociado y no puede editarse, póngase en contacto con él"
		}
	},
	"26": {
		"categoria" : 'important',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se han encontrado estudios asociados a tu perfil. Por favor acude a secretaría de alumnos para actualizar tu información"
		}
	},
	"27": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Por favor revisa los Datos de la Práctica, la fecha de inicio debe ser anterior a la fecha de finalización de las prácticas."
		}
	},
	"28": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La contraseña no es segura"
		}
	},
	"29": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya hay un contacto registrado en la empresa con este email"
		}
	},
	"30": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La candidatura ya ha sido tramitada, no puedes desinscribirte"
		}
	},
	"31": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se encuentra la candidatura"
		}
	},
	"32": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Lo sentimos, estás dado de baja del servicio y no puedes inscribirte a ofertas"
		}
	},
	"33": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El cif no tiene formato correcto"
		}
	},
	"34": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea"
		}
	},
	"35": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La encuesta no es accesible.",
			"to" : '/'
		}
	},
	"36": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La encuesta no es para usuarios existentes.",
			"to" : '/'
		}
	},
	"37": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			"to" : '/'
		}
	},
	"38": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Atención. La encuesta a la que estás tratando de acceder ya no está disponible para tu perfil. No estas en el target de la encuesta.",
			"to" : '/'
		},

	},
	"39": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya has contestado esta encuesta",
			"to" : '/'
		}
	},
	"40": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Faltan preguntas por contestar"
		}
	},
	"42": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El enlace está caducado o ya ha sido utilizado"
		}
	},
	"41": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se encuentran los estudios de la titulación indicada"
		}
	},
	"44": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El email indicado pertenece a otra empresa, indique otro."
		}
	},
	"46": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La extensión del archivo no esta permitida"
		}
	},
	"47": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Esta oferta no va dirigida a tu titulación"
		}
	},
	"48": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Acción no permitida"
		}
	},
	"52": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No tienes superados los créditos necesarios para inscribirte a la oferta"
		}
	},
	"53": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta va dirigida a estudiantes sin prácticas pendientes"
		}
	},
	"54": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Para poder ser candidato a la oferta, se necesita estar en búsqueda activa. Para activarlo dirígete a Mi CV -> Datos de interés"
		}
	},
	"55": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Es necesario tener subido el CV propio para realizar la operación"
		}
	},
	"56": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya tienes subido este documento, si quieres actualizarlo, elimínalo y vuélvelo a adjuntar."
		}
	},
	"57": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Es necesario tener al menos una formación para realizar la operación"
		}
	},
	"61": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El DNI se encuentra entre los ya registrados. Accede con tu contraseña."
		}
	},
	"63": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puedes inscribirte. Ya eres candidato del máximo de ofertas internas permitidas"
		}
	},
	"64": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Tu perfil no tiene todos los datos necesarios para optar a ofertas de empleo, puedes completar tus datos en tu espacio personal"
		}
	},
	"68": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Como antiguo alumno debes tener registrada al menos una titulación UFV."
		}
	},
	"69": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Su empresa no está autorizada para realizar búsquedas a la carta. Si lo desea, puede solicitar permiso contactando con nosotros"
		}
	},
	"70": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El IBAN no es válido"
		}
	},
	"72": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "El DNI indicado no es válido o está mal formado. Contacta con nosotros en caso de que tengas cualquier duda."
		}
	},
	"73": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El número de seguridad social no está bien formado"
		}
	},
	"74": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El DNI no está bien formado"
		}
	},
	"75": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El número de seguridad social y El IBAN no son válidos"
		}
	},
	"500": {
		"categoria" : 'important',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El servicio actualmente no esta disponible"
		}
	},
	"600" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "¡Enhorabuena!",
			"cuerpo" : "Te has inscrito correctamente"
		}
	},
	"601" : {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "¡Enhorabuena!",
			"cuerpo" : "Documento añadido correctamente"
		}
	},
	"602" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Contacto recibido",
			"cuerpo" : "Nos pondremos en contacto contigo lo antes posible"
		}
	},
	"603" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Recuerdo de contraseña",
			"cuerpo" : "Te hemos enviado un correo electrónico con las instrucciones para recuperar tu contraseña"
		}
	},
	"604" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Memoria adjunta correctamente"
		}
	},
	"605" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Oferta creada correctamente",
			"to" : "/"
		}
	},
	"606" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Enviado correctamente",
			"to" : "/"
		}
	},
	"607" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "La empresa ha sido dada de alta correctamente. Validaremos los datos facilitados y te enviaremos un mail confirmando tu registro en el menor tiempo posible.",
			"to" : "/login/empresas"
		}
	},
	"608" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Los candidatos han sido solicitados correctamente.",
			"to" : "/busqueda-carta"
		}
	},
	"609" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "El contacto ha sido creado",
		}
	},
	"610" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "El contacto ha sido editado correctamente",
		}
	},
	"611" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Contraseña cambiada correctamente",
		}
	},
	"612" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "La encuesta ha sido contestada correctamente",
			"to" : "/"
		}
	},
	"613" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "El usuario indicado no existe. Contacta con nosotros en caso de que tengas cualquier duda.",
		}
	},
	"614" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Su contraseña se ha actualizado correctamente",
			"to" : "/login/empresas"
		}
	},
	"615" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Tu propuesta se ha registrado correctamente, la revisaremos y te informaremos para su tramitación.",
			"to" : "/"
		}
	},
	"616" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Su propuesta se ha registrado correctamente, la revisaremos y le informaremos para su tramitación.",
			"to" : "/"
		}
	},
	"617" : {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "No se encuentra ningún estudiante con el DNI indicado. Por favor indique el dato de DNI sin espacios ni símbolos . Pruebe a indicar el DNI con y sin letra , y en caso de continuar con el problema contacte con nosotros.",
		}
	},
	"618" : {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "¡Enhorabuena!",
			"cuerpo" : "Los datos se han añadido correctamente"
		}
	},
}



// WEBPACK FOOTER //
// ./src/errors/index.js